module.exports = __webpack_public_path__ + "static/media/country-bg.81449cfe.svg";